import React from "react";
import {Box, CircularProgress} from "@mui/material";

export function CustomLoader() {
    return <Box justifyContent={"center"} width={"100%"} display={"flex"}>
        <CircularProgress/>
    </Box>
}
